import type { SettingState } from './types'

export const selectSetting = (state: { setting: SettingState }) => state.setting
export const selectSettingErrors = (state: { setting: SettingState }) => state.setting.errors
